// extracted by mini-css-extract-plugin
export default {"startGameView":"StartGameView_startGameView__dvH65","logo":"StartGameView_logo__sO0q+","player":"StartGameView_player__gZnoZ","buttons":"StartGameView_buttons__Rovqi"};